<template>
	<BaseModal
		:visible="visible"
		:title="$t('change_n', { name: $t('status') })"
		size="2xl"
		:loading="state.loading"
		:button-name="$t('save')"
		@close="emit('close')"
		@button-click="submit"
	>
		<div class="flex flex-col">
			<div class="flex flex-col px-6 pb-2 pt-6">
				<div
					v-for="(status, i) in statuses"
					:key="i"
					class="mb-4 flex cursor-pointer items-center rounded-lg border-2 bg-opacity-0 px-6 py-3 text-sm duration-300 hover:bg-opacity-10"
					:class="{
						[status.bgClass]: status.value === state.selectedStatus,
						[status.borderClass]: status.value === state.selectedStatus,
						[status.txtClass]: status.value === state.selectedStatus,
						'text-gray-500 bg-gray-300 border-gray-300': status.value !== state.selectedStatus
					}"
					@click="select(status.value)"
				>
					{{ status.name }}
				</div>
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import type { DevTicket } from "~/models/dev-ticket"

const devTicketStore = useDevTicketStore()
const { $toastErrors, $toast, $i18n } = useNuxtApp()

const emit = defineEmits<{
	close: []
	select: [string]
	done: [DevTicket]
}>()

const props = defineProps<{
	visible: boolean
	data: DevTicket | null
}>()

const state = reactive({
	loading: false,
	selectedStatus: ""
})

const statuses = computed(() => devTicketStore.statuses)

watch(
	() => props.visible,
	() => (state.selectedStatus = props.data?.status || "")
)

watch(
	() => props.data,
	() => (state.selectedStatus = props.data?.status || "")
)

const select = (status: string) => {
	state.selectedStatus = status
}

const submit = async () => {
	state.loading = true
	try {
		const ticket = await devTicketStore.editDevTicket({
			id: props.data?.id!,
			company_id: props.data?.company_id || undefined,
			status: state.selectedStatus as any
		})
		$toast.success({
			message: $i18n.t("n_changed", {
				name: $i18n.t("status")
			})
		})
		emit("select", state.selectedStatus)
		emit("done", ticket)
		emit("close")
	} catch (e) {
		$toastErrors(e)
	}
	state.loading = false
}

onMounted(() => {
	state.selectedStatus = props.data?.status || ""
})
</script>
